import {ContextMenuComponent} from './ContextMenuComponent'
import './scss/contextmenu.scss'

const ContextMenuPackage = {
    name: 'dw-context-menu',
    configure: function (configurator) {
        configurator.addToolGroup('context-menu-spelling')
        configurator.addComponent('dw-context-menu', ContextMenuComponent)
    }
}

export {ContextMenuPackage}
